import { Routes } from '@angular/router';
import { RouteLocations } from './common/routing/route-locations.enum';
import { LoggedInRouteGuard } from './common/routing/route-guards/logged-in.guard';

export const routes: Routes = [
  {
    path: RouteLocations.Home.relativeUrl,
    loadComponent: () => import('./home/home.component').then(_ => _.HomeComponent),
  },
  {
    path: RouteLocations.Dashboard.relativeUrl,
    loadChildren: () => import('./dashboard/dashboard.module').then(_ => _.DashboardModule),
    canActivate: [LoggedInRouteGuard],
  },
  {
    path: RouteLocations.Login.relativeUrl,
    loadChildren: () => import('./login/login.module').then(_ => _.LoginModule),
  },
  {
    path: RouteLocations.TermsAndConditions.relativeUrl,
    loadComponent: () => import('./terms/terms.component').then(_ => _.TermsComponent),
  },
  {
    path: RouteLocations.PrivacyPolicy.relativeUrl,
    loadComponent: () => import('./privacy/privacy.component').then(_ => _.PrivacyComponent),
  },
  {
    path: RouteLocations.NotFound.relativeUrl,
    loadComponent: () => import('./not-found/not-found.component').then(_ => _.NotFoundComponent),
  },
  {
    path: '**',
    redirectTo: RouteLocations.Home.absoluteUrl,
  },
];
